import React, { useContext } from 'react';

import i18n from '../../i18n';
// import PropTypes from 'prop-types';
import styles from './SearchResult.module.scss';
import SearchResultItem from '../SearchResultItem';
import classNames from 'classnames';
import CardAjaxLoader from '../CardAjaxLoader';

const SearchResult = ({ ctx, categoryRewrites, lang }) => {
    const { state, dispatch } = useContext(ctx);
    const quotedSearchTerm = `"${state.searchTerm}"`;

    return (
        <div
            className={classNames(
                styles['SearchResult'],
                !state.items.length && styles['SearchResult--NoHits']
            )}>
            {!!state.hasFetched && !state.loading ? (
                <>
                    {!state.items.length || state.error ? (
                        <div className={styles['SearchResult__NoHitsWrapper']}>
                            <h1 className={styles['SearchResult__NoHitsTitle']}>
                                {!!state.error
                                    ? i18n.t('SearchResult.error.title')
                                    : i18n.t('SearchResult.noHits.title')}
                                {quotedSearchTerm}
                            </h1>
                            <p className={styles['SearchResult__NoHitsText']}>
                                {!!state.error
                                    ? i18n.t('SearchResult.error.text')
                                    : i18n.t('SearchResult.noHits.text')}
                            </p>
                        </div>
                    ) : (
                        <>
                            <div className={styles['SearchResult__Title']}>
                                {state.totalResults > 1
                                    ? i18n.t('SearchResult.resultsText', {
                                          totalResults: state.totalResults,
                                      })
                                    : i18n.t('SearchResult.resultText', {
                                          totalResults: state.totalResults,
                                      })}
                                {quotedSearchTerm}
                            </div>
                            {state.items.map((item, index) => (
                                <SearchResultItem
                                    key={index}
                                    categoryRewrites={categoryRewrites}
                                    lang={lang}
                                    {...item}
                                />
                            ))}
                        </>
                    )}
                </>
            ) : (
                <>
                    {!!state.loading ? (
                        <>
                            <div
                                className={
                                    styles['SearchResult__TitleLoader']
                                }></div>
                            <div
                                className={
                                    styles['SearchResult__LoaderWrapper']
                                }>
                                {Array(8)
                                    .fill()
                                    .map((stub, index) => (
                                        <CardAjaxLoader
                                            key={index}
                                            modifiers={['SearchResultItem']}
                                        />
                                    ))}
                            </div>
                        </>
                    ) : (
                        // when ?q= is missing
                        <>
                            {!!state.hasFetched && (
                                <div className={styles['SearchResult__Title']}>
                                    {i18n.t('SearchResult.resultText', {
                                        totalResults: state.totalResults,
                                    })}
                                    {quotedSearchTerm}
                                </div>
                            )}
                        </>
                    )}
                </>
            )}
        </div>
    );
};

SearchResult.propTypes = {};

export default SearchResult;
